import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FlexGap, FlexAlign, FlexJustify, StackHorizontal } from '@ukpostbox/frontend-framework';
import { faBatteryFull } from '@fortawesome/pro-solid-svg-icons/faBatteryFull';
import { faLaptop } from '@fortawesome/pro-solid-svg-icons/faLaptop';
import { BatteryTypeEntryType } from '../../Types/ForwardingBatchTypes';
import { BatteryEntry } from './BatteryEntry';

function LithiumBatteryWithEquipment(props: BatteryTypeEntryType) {
	return (
		<BatteryEntry
			name='lithiumBatteriesWithEquipment'
			media={
				<StackHorizontal
					gap={FlexGap.ExtraSmall}
					align={FlexAlign.Center}
					justify={FlexJustify.Center}
					extraClass='mb-lg'
				>
					<FontAwesomeIcon icon={faBatteryFull} size='3x' rotation={270} />
					<FontAwesomeIcon icon={faBatteryFull} size='3x' rotation={270} />
					<FontAwesomeIcon icon={faLaptop} size='3x' />
				</StackHorizontal>
			}
			title='Packed With Equipment'
			description={[
				{ value: 'Batteries must be for the device that they are shipped with' },
				{ value: 'No Powerbanks', important: true },
			]}
			defaultSelected={props.defaultSelected}
			callBack={(state) => props.onChangeCallback(state)}
			complete={props.complete}
			readOnly={props.readOnly}
		/>
	);
}

export { LithiumBatteryWithEquipment };
